"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Vanush.Voskanyan on 10/5/2018.
 */
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var core_1 = require("@angular/core");
var boolean_operator_names_factory_1 = require("../boolean-operator-names-factory");
var material_1 = require("@angular/material");
require("rxjs/add/operator/map");
var row_formatting_model_1 = require("./model/row-formatting-model");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var Observable_1 = require("rxjs/Observable");
var default_text_style_dto_factory_1 = require("../text-style/default-text-style-dto-factory");
var ComparisonType;
(function (ComparisonType) {
    ComparisonType[ComparisonType["memberToMember"] = 1] = "memberToMember";
    ComparisonType[ComparisonType["memberToValue"] = 2] = "memberToValue";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
var SisRowFormattingComponent = /** @class */ (function () {
    function SisRowFormattingComponent(_booleanOperatorNamesFactory, _measurePathService) {
        this._booleanOperatorNamesFactory = _booleanOperatorNamesFactory;
        this._measurePathService = _measurePathService;
    }
    SisRowFormattingComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes['selectedRowFormattingModel']) {
            this._setInitialValues();
            this._allMeasurePaths = Observable_1.Observable.fromPromise(this._measurePathService.getAllMeasurePaths(this.selectedRowFormattingModel.dataSetId));
        }
        if (changes && changes['branchIndexMeasurePathHolderIdPairs']) {
            this._branchIndexesForFirstMemberCombobox = Array.from(this.branchIndexMeasurePathHolderIdPairs.keys());
            this._branchIndexesForSecondMemberCombobox = Array.from(this.branchIndexMeasurePathHolderIdPairs.keys());
        }
    };
    SisRowFormattingComponent.prototype.ngOnDestroy = function () {
        this._drawer.toggle(!this._drawer.opened);
    };
    SisRowFormattingComponent.prototype.getMeasurePath = function (pair) {
        return this._allMeasurePaths.map(function (data) {
            return data.get(pair);
        });
    };
    SisRowFormattingComponent.prototype.onDoneClick = function () {
        var formattingConditions = this.selectedRowFormattingModel.rowFormattingRule.getFormattingConditions();
        var newFormattingCondition = this.createFormattingCondition();
        if (this._isFormattingConditionIndexGiven()) {
            formattingConditions[this.selectedRowFormattingModel.formattingConditionIndex] = newFormattingCondition;
        }
        else {
            formattingConditions.push(newFormattingCondition);
        }
        this.conditionsChange.emit();
        // back to previous page
        this.resetAndGoBack();
    };
    SisRowFormattingComponent.prototype.isValid = function () {
        if (this._selectedOperatorType !== undefined) {
            if (this._selectedOperatorType === idm_report_export_service_client_js_1.BooleanOperatorType.BETWEEN) {
                return this._firstMemberBranchIndex !== undefined
                    && this._valueTo !== undefined
                    && this._valueTo !== null
                    && this._valueFrom !== undefined
                    && this._valueFrom !== null
                    && this._valueFrom <= this._valueTo;
            }
            switch (this._selectedComparisonType) {
                case ComparisonType.memberToValue:
                    return this._value !== undefined
                        && this._value !== null
                        && this._firstMemberBranchIndex !== undefined;
                case ComparisonType.memberToMember:
                    return this._firstMemberBranchIndex !== undefined
                        && this._secondMemberBranchIndex !== undefined;
                default:
                    return false;
            }
        }
        else {
            return false;
        }
    };
    SisRowFormattingComponent.prototype.createFormattingCondition = function () {
        var newFormattingCondition;
        if (this._selectedOperatorType === idm_report_export_service_client_js_1.BooleanOperatorType.BETWEEN) {
            newFormattingCondition = new idm_report_export_service_client_js_1.BetweenFormattingConditionDto();
            newFormattingCondition.valueFrom = this._valueFrom;
            newFormattingCondition.valueTo = this._valueTo;
            newFormattingCondition.measureElementBranchIndex = this._firstMemberBranchIndex;
            newFormattingCondition.booleanOperator = idm_report_export_service_client_js_1.BooleanOperatorDtoFactory.newInstance(this._selectedOperatorType);
            newFormattingCondition.textStyle = this._textStyle;
            return newFormattingCondition;
        }
        switch (this._selectedComparisonType) {
            case ComparisonType.memberToValue:
                newFormattingCondition = new idm_report_export_service_client_js_1.ConstantFormattingConditionDto();
                newFormattingCondition.value = this._value;
                newFormattingCondition.measureElementBranchIndex = this._firstMemberBranchIndex;
                break;
            case ComparisonType.memberToMember:
                newFormattingCondition = new idm_report_export_service_client_js_1.MeasureToMeasureComparisonFormattingConditionDto();
                newFormattingCondition.measureElement1BranchIndex = this._firstMemberBranchIndex;
                newFormattingCondition.measureElement2BranchIndex = this._secondMemberBranchIndex;
                break;
        }
        newFormattingCondition.booleanOperator = idm_report_export_service_client_js_1.BooleanOperatorDtoFactory.newInstance(this._selectedOperatorType);
        newFormattingCondition.textStyle = this._textStyle;
        return newFormattingCondition;
    };
    SisRowFormattingComponent.prototype.resetAndGoBack = function () {
        this._resetState();
    };
    SisRowFormattingComponent.prototype.getOperatorMessageKey = function (operator) {
        return operator && operator.operatorMessageKey;
    };
    SisRowFormattingComponent.prototype.isMemberToMemberComparisonSelected = function () {
        return this._selectedComparisonType === ComparisonType.memberToMember;
    };
    SisRowFormattingComponent.prototype.isMemberToValueComparisonSelected = function () {
        return this._selectedComparisonType === ComparisonType.memberToValue;
    };
    SisRowFormattingComponent.prototype.isBetweenOperatorSelected = function () {
        return this._selectedOperatorType === idm_report_export_service_client_js_1.BooleanOperatorType.BETWEEN;
    };
    SisRowFormattingComponent.prototype.getOperatorType = function (operator) {
        return operator && operator.operatorType;
    };
    SisRowFormattingComponent.prototype.isOneMeasurePresent = function () {
        return this.branchIndexMeasurePathHolderIdPairs.size === 1;
    };
    SisRowFormattingComponent.prototype.checkFirstMemberCombobox = function (newMeasureBranchIndex) {
        if (newMeasureBranchIndex === this._secondMemberBranchIndex) {
            this._secondMemberBranchIndex = undefined;
        }
    };
    SisRowFormattingComponent.prototype.checkSecondMemberCombobox = function (newMeasureBranchIndex) {
        if (newMeasureBranchIndex === this._firstMemberBranchIndex) {
            this._firstMemberBranchIndex = undefined;
        }
    };
    /**
     * Changes the flag from which the component is created or destroyed
     */
    SisRowFormattingComponent.prototype._resetState = function () {
        this.selectedRowFormattingModel.formattingConditionIndex = undefined;
    };
    SisRowFormattingComponent.prototype._isFormattingConditionIndexGiven = function () {
        return this.selectedRowFormattingModel.formattingConditionIndex !== null && typeof this.selectedRowFormattingModel.formattingConditionIndex !== 'undefined';
    };
    SisRowFormattingComponent.prototype._setInitialValues = function () {
        if (this._isFormattingConditionIndexGiven()) {
            var givenFormattingCondition = this.selectedRowFormattingModel.rowFormattingRule.getFormattingConditions()[this.selectedRowFormattingModel.formattingConditionIndex];
            if (givenFormattingCondition instanceof idm_report_export_service_client_js_1.BetweenFormattingConditionDto) {
                this._firstMemberBranchIndex = givenFormattingCondition.measureElementBranchIndex;
                this._valueFrom = givenFormattingCondition.valueFrom;
                this._valueTo = givenFormattingCondition.valueTo;
            }
            else if (givenFormattingCondition instanceof idm_report_export_service_client_js_1.ConstantFormattingConditionDto) {
                this._firstMemberBranchIndex = givenFormattingCondition.measureElementBranchIndex;
                this._value = givenFormattingCondition.value;
                this._selectedComparisonType = ComparisonType.memberToValue;
            }
            else if (givenFormattingCondition instanceof idm_report_export_service_client_js_1.MeasureToMeasureComparisonFormattingConditionDto) {
                this._firstMemberBranchIndex = givenFormattingCondition.measureElement1BranchIndex;
                this._secondMemberBranchIndex = givenFormattingCondition.measureElement2BranchIndex;
                this._selectedComparisonType = ComparisonType.memberToMember;
            }
            else {
                throw new Error('Invalid formatting condition type');
            }
            this._selectedOperatorType = givenFormattingCondition.booleanOperator.getOperatorType();
            this._textStyle = idm_report_export_service_client_js_1.TextStyleDto.clone(this.selectedRowFormattingModel.rowFormattingRule.getFormattingConditions()[this.selectedRowFormattingModel.formattingConditionIndex].getStyle());
        }
        else {
            if (this.isOneMeasurePresent()) {
                this._selectedComparisonType = ComparisonType.memberToValue;
            }
            else {
                this._selectedComparisonType = ComparisonType.memberToMember;
            }
            this._textStyle = default_text_style_dto_factory_1.DefaultTextStyleDtoFactory.getDefaultTextStyle();
        }
    };
    Object.defineProperty(SisRowFormattingComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "valueFrom", {
        get: function () {
            return this._valueFrom;
        },
        set: function (value) {
            this._valueFrom = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "valueTo", {
        get: function () {
            return this._valueTo;
        },
        set: function (value) {
            this._valueTo = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "selectedComparisonType", {
        get: function () {
            return this._selectedComparisonType;
        },
        set: function (value) {
            this._selectedComparisonType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "firstMemberBranchIndex", {
        get: function () {
            return this._firstMemberBranchIndex;
        },
        set: function (value) {
            this._firstMemberBranchIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "secondMemberBranchIndex", {
        get: function () {
            return this._secondMemberBranchIndex;
        },
        set: function (value) {
            this._secondMemberBranchIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "selectedOperatorType", {
        get: function () {
            return this._selectedOperatorType;
        },
        set: function (value) {
            this._selectedOperatorType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "caption", {
        get: function () {
            return this.selectedRowFormattingModel.caption;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "textStyle", {
        get: function () {
            return this._textStyle;
        },
        set: function (value) {
            this._textStyle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "dataSetId", {
        get: function () {
            return this.selectedRowFormattingModel.dataSetId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "operators", {
        get: function () {
            return this._booleanOperatorNamesFactory.getOperators();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "branchIndexesForFirstMemberCombobox", {
        get: function () {
            return this._branchIndexesForFirstMemberCombobox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingComponent.prototype, "branchIndexesForSecondMemberCombobox", {
        get: function () {
            return this._branchIndexesForSecondMemberCombobox;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", material_1.MatDrawer)
    ], SisRowFormattingComponent.prototype, "_drawer", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", row_formatting_model_1.RowFormattingModel)
    ], SisRowFormattingComponent.prototype, "selectedRowFormattingModel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Map)
    ], SisRowFormattingComponent.prototype, "branchIndexMeasurePathHolderIdPairs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisRowFormattingComponent.prototype, "conditionsChange", void 0);
    SisRowFormattingComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-row-formatting',
            template: require('./sis-row-formatting.component.html'),
            styles: [require('./sis-row-formatting.component.css')]
        }),
        __metadata("design:paramtypes", [boolean_operator_names_factory_1.BooleanOperatorNamesFactory, idm_dataset_service_client_js_1.MeasurePathService])
    ], SisRowFormattingComponent);
    return SisRowFormattingComponent;
}());
exports.SisRowFormattingComponent = SisRowFormattingComponent;
//# sourceMappingURL=sis-row-formatting.component.js.map